import { render } from "./CurrentLocation.vue?vue&type=template&id=1bf45ca7&scoped=true"
import script from "./CurrentLocation.vue?vue&type=script&lang=js"
export * from "./CurrentLocation.vue?vue&type=script&lang=js"

import "./CurrentLocation.vue?vue&type=style&index=0&id=1bf45ca7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf45ca7"]])

export default __exports__